import { Errors, ValidateFieldsProps } from '../types';
export const validateFields = ({ form, fields, setErrors }: ValidateFieldsProps): boolean => {
  const errors: Errors = {};

  if (!form.inventory) errors.inventory = 'inventory-error';
  if (!form.dataType) errors.datatType = 'dataType-error';

  if (form.inventory && form.dataType && fields) {
    const activeFields = fields;
    const requiredFields = activeFields.filter((field) => field.required);

    if (requiredFields.length === 1) {
      const field = requiredFields[0];
      const fieldValue = (form.query?.[field.name] ?? '').trim();
      if (!fieldValue) {
        errors[field.name] = field.label;
      }
    } else if (requiredFields.length > 1) {
      const anyFilled = requiredFields.some(
        (field) => (form.query?.[field.name] ?? '').trim() !== ''
      );

      if (!anyFilled) {
        requiredFields.forEach(() => (errors.inlineError = 'inline-error'));
      }
    }

    for (const field of activeFields) {
      let fieldValue = field.replaceAllSpace
        ? (form.query?.[field.name] ?? '').replace(/\s+/g, '')
        : (form.query?.[field.name] ?? '').trim();
      if (!fieldValue) break;
      if (field.pattern && !field.pattern.test(fieldValue) && field.type === 'number') {
        errors.numericError = `numeric-error`;
      }
    }
  }

  setErrors(errors);
  return Object.keys(errors).length === 0;
};
